/* eslint-disable max-len */
import React from 'react';

const SizeSmallRightIcon = props => (
  <svg
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={19}
    height={19}
    viewBox="0 0 19 19"
    {...props}
  >
    <defs>
      <path
        id="small-size-right-path"
        d="M2 15.8v-.6c0-.11.09-.2.2-.2h10.6c.11 0 .2.09.2.2v.6a.2.2 0 0 1-.2.2H2.2a.2.2 0 0 1-.2-.2zm0-3v-.6c0-.11.09-.2.2-.2h4.6c.11 0 .2.09.2.2v.6a.2.2 0 0 1-.2.2H2.2a.2.2 0 0 1-.2-.2zm0-3v-.6c0-.11.09-.2.2-.2h4.6c.11 0 .2.09.2.2v.6a.2.2 0 0 1-.2.2H2.2a.2.2 0 0 1-.2-.2zm0-3v-.6c0-.11.09-.2.2-.2h4.6c.11 0 .2.09.2.2v.6a.2.2 0 0 1-.2.2H2.2a.2.2 0 0 1-.2-.2zm0-3v-.6c0-.11.09-.2.2-.2h10.6c.11 0 .2.09.2.2v.6a.2.2 0 0 1-.2.2H2.2a.2.2 0 0 1-.2-.2zM16.8 13H9.2a.2.2 0 0 1-.2-.2V6.2c0-.11.09-.2.2-.2h7.6c.11 0 .2.09.2.2v6.6a.2.2 0 0 1-.2.2zm-.8-1V7h-6v5h6z"
      />
    </defs>
    <g fillRule="evenodd">
      <mask id="small-size-right-mask">
        <use xlinkHref="#small-size-right-path" />
      </mask>
      <use fillRule="nonzero" xlinkHref="#small-size-right-path" />
    </g>
  </svg>
);

export default SizeSmallRightIcon;
